module.exports = __webpack_public_path__ + "img/businessPlan.bd3a30ef.svg";